import affiliateNewsApi from '../api/affiliateNews'

export default {
    state: {
        affiliateNews: {},
        filters: {},
    },
    namespaced: true,
    mutations: {
        async getAffiliateNews(state, affiliateNews) {
            state.affiliateNews = affiliateNews;
        },
        getAffiliateNewsFilterData(state, filterData) {
            state.filters = filterData.filters;
        },
        createOrUpdateAffiliateNews(state, news) {
            state.affiliateNews.data = [...state.affiliateNews.data.filter(n => n.id !== news.id)];
            state.affiliateNews.data.push(news);
            state.affiliateNews.count += 1;
        }
    },
    actions: {
        async getAffiliateNewsStore({ commit }, data) {
            try {
                const pagination = {
                    limit: data.limit,
                    page: data.page
                }
                const sorting = {
                    orderBy: data.orderBy,
                    orderDirectionAsc: data.orderDirectionAsc
                }
                const filters = data.filters

                const resp = await affiliateNewsApi.getAffiliateNews(pagination, sorting, filters);
                commit('getAffiliateNews', resp);
                return resp;
            } catch (e) {
                console.error('getAffiliateNewsStore Error:', e)
            }
        },
        async getAffiliateNewsFilterDataStore({ commit }, data) {
            try {
                const resp = await affiliateNewsApi.getAffiliateNewsFilterData(data);
                commit('getAffiliateNewsFilterData', resp);
                return resp;
            } catch (e) {
                console.error('getAffiliateNewsFilterDataStore Error:', e)
            }
        },
        async createOrUpdateAffiliateNewsStore({ commit }, data) {
            try {
                const resp = await affiliateNewsApi.createNews(data);
                commit('createOrUpdateAffiliateNews', resp);
                return resp;
            } catch (e) {
                console.error('getAffiliateAlertsFilterDataStore Error:', e)
            }
        }
    },
    getters: {
        filters: state => state.filters,
        getAffiliateNews: state => state.affiliateNews,
    },
}
